import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreServiceService } from '../core/core-service.service';
import { ReportParameters } from '../Models/report-parameters';
import { PaymentWithFastag } from '../Models/Report/payment-with-fastag';
import { SELECT_TAG_MOVEMENT } from '../Models/Report/SELECT_TAG_MOVEMENT';
import { SELECT_BLACKLIST_WHITELIST_CUSTOMERS } from '../Models/Report/SELECT_BLACKLIST_WHITELIST_CUSTOMERS';
import { SELECT_DEVICE_LOG } from '../Models/Report/SELECT_DEVICE_LOG';
import { SELECT_GROUP_LIST } from '../Models/Report/SELECT_GROUP_LIST';
import { SELECT_CUSTOMER_LIST } from '../Models/Report/SELECT_CUSTOMER_LIST';
import { SELECT_CUSTOMER_LOG } from '../Models/Report/SELECT_CUSTOMER_LOG';
import { PAYMENT_WITH_FASTAG_OCASSIONAL_USER } from '../Models/Report/PAYMENT_WITH_FASTAG_OCASSIONAL_USER';
import { SELECT_CARD_INSERT_PARKING_AREA } from '../Models/Report/SELECT_CARD_INSERT_PARKING_AREA';
import { SELECT_CARD_BLOCKED } from '../Models/Report/SELECT_CARD_BLOCKED';
import { SELECT_CARD_UNBLOCKED } from '../Models/Report/SELECT_CARD_UNBLOCKED';
import { SELECT_ANTI_PASS_BACK_RESET } from '../Models/Report/SELECT_ANTI_PASS_BACK_RESET';
import { SELECT_CARD_SOLD } from '../Models/Report/SELECT_CARD_SOLD';
import { SELECT_CARD_RENEWED } from '../Models/Report/SELECT_CARD_RENEWED';
import { SHIFT_SUMMARY } from '../Models/Report/SHIFT_SUMMARY';
import { SELECT_PAYMENT_WITH_FASTAGE } from '../Models/Report/SELECT_PAYMENT_WITH_FASTAGE';
import { SELECT_GROUP_COUNTER } from '../Models/Report/SELECT_GROUP_COUNTER';
import { SELECT_MANUAL_BARRIER_OPEN_CLOSE } from '../Models/Report/SELECT_MANUAL_BARRIER_OPEN_CLOSE';
import { Status } from '../Models/status';
import { TrnsOperations } from '../Models/trns-operations';
import { SELECT_FASTAG_RECONCILATION } from '../Models/Report/SELECT_FASTAG_RECONCILATION';
import { SELECT_KNOCK_OFF } from '../Models/Report/SELECT_KNOCK_OFF';
import { SELECT_ALL_MOVEMENTS_BY_DAY_REP } from '../Models/Report/SELECT_ALL_MOVEMENTS_BY_DAY_REP';
import { SELECT_RECONCILLATION_STATISTICS_REP } from '../Models/Report/SELECT_RECONCILLATION_STATISTICS_REP';
import { SELECT_REVENUE_STATISTICS_REP } from '../Models/Report/SELECT_REVENUE_STATISTICS_REP';
import { SELECT_STAY_TIME_STAMP_REPORT } from '../Models/Report/SELECT_STAY_TIME_STAMP_REPORT';
import { Get_Cab_Report } from '../Models/Report/Get_Cab_Report';
import { GET_CABCARDWISE_SUMMARY } from '../Models/Report/GET_CABCARDWISE_SUMMARY';
import { GET_CABCARD_DETAILS } from '../Models/Report/GET_CABCARD_DETAILS';
import { GET_CAB_SUMMARY } from '../Models/Report/GET_CAB_SUMMARY';
import { OFFLINE_FASTAG_DATA } from '../Models/Report/OFFLINE_FASTAG_DATA';
import { PREBOOKING } from '../Models/Report/PREBOOKING';
import { SELECT_T1__COMMERCIAL } from '../Models/Report/SELECT_T1__COMMERCIAL';
import { SELECT_T1__PRIVATE } from '../Models/Report/SELECT_T1__PRIVATE';
import { SELECT_T1__FORECOURT } from '../Models/Report/SELECT_T1__FORECOURT';
import { SELECT_HANDHELD_MANUAL } from '../Models/Report/SELECT_HANDHELD_MANUAL';
import { SELECT_T1__ENTRIES } from '../Models/Report/SELECT_T1_ENTRIES';
import { SELECT_ANPR } from '../Models/Report/SELECT_ANPR';
import { SELECT_ANPRDATA } from '../Models/Report/SELECT_ANPRDATA';

@Injectable({
  providedIn: 'root'
})
export class ReportApiService {

  private BaseApiPath: string;
  private CloudApi_Path: string;
  constructor(private http: HttpClient, private coreService: CoreServiceService) {

    this.BaseApiPath = this.coreService.appSettings && this.coreService.appSettings.ParkBaseApiPath;
    this.CloudApi_Path = this.coreService.appSettings && this.coreService.appSettings.CloudApiPath;
  }
  public GetOperations(reportParameters: ReportParameters): Observable<TrnsOperations[]> {
    const ApiUrl = this.BaseApiPath + 'report/GetOperations';
    return this.http.post<TrnsOperations[]>(ApiUrl, reportParameters);
  }
  public GetPaymentWithFastag(reportParameters: ReportParameters): Observable<PaymentWithFastag[]> {
    const ApiUrl = this.BaseApiPath + 'report/GetPaymentwithfastag';
    return this.http.post<PaymentWithFastag[]>(ApiUrl, reportParameters);
  }
  public SELECT_TAG_MOVEMENT(reportParameters: ReportParameters): Observable<SELECT_TAG_MOVEMENT[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_TAG_MOVEMENT';
    return this.http.post<SELECT_TAG_MOVEMENT[]>(ApiUrl, reportParameters);
  }
  public SELECT_BLACKLIST_WHITELIST_CUSTOMERS(reportParameters: ReportParameters): Observable<SELECT_BLACKLIST_WHITELIST_CUSTOMERS[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_BLACKLIST_WHITELIST_CUSTOMERS';
    return this.http.post<SELECT_BLACKLIST_WHITELIST_CUSTOMERS[]>(ApiUrl, reportParameters);
  }
  public SELECT_DEVICE_LOG(reportParameters: ReportParameters): Observable<SELECT_DEVICE_LOG[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_DEVICE_LOG';
    return this.http.post<SELECT_DEVICE_LOG[]>(ApiUrl, reportParameters);
  }
  public SELECT_GROUP_LIST(reportParameters: ReportParameters): Observable<SELECT_GROUP_LIST[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_GROUP_LIST';
    return this.http.post<SELECT_GROUP_LIST[]>(ApiUrl, reportParameters);
  }
  public SELECT_CUSTOMER_LIST(reportParameters: ReportParameters): Observable<SELECT_CUSTOMER_LIST[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_CUSTOMER_LIST';
    return this.http.post<SELECT_CUSTOMER_LIST[]>(ApiUrl, reportParameters);
  }

  public SELECT_CUSTOMER_LOG(reportParameters: ReportParameters): Observable<SELECT_CUSTOMER_LOG[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_CUSTOMER_LOG';
    return this.http.post<SELECT_CUSTOMER_LOG[]>(ApiUrl, reportParameters);
  }

  public PAYMENT_WITH_FASTAG_OCASSIONAL_USER(reportParameters: ReportParameters): Observable<PAYMENT_WITH_FASTAG_OCASSIONAL_USER[]> {
    const ApiUrl = this.BaseApiPath + 'report/PAYMENT_WITH_FASTAG_OCASSIONAL_USER';
    return this.http.post<PAYMENT_WITH_FASTAG_OCASSIONAL_USER[]>(ApiUrl, reportParameters);
  }
  public SELECT_CARD_INSERT_PARKING_AREA(reportParameters: ReportParameters): Observable<SELECT_CARD_INSERT_PARKING_AREA[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_CARD_INSERT_PARKING_AREA';
    return this.http.post<SELECT_CARD_INSERT_PARKING_AREA[]>(ApiUrl, reportParameters);
  }
  public SELECT_CARD_BLOCKED(reportParameters: ReportParameters): Observable<SELECT_CARD_BLOCKED[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_CARD_BLOCKED';
    return this.http.post<SELECT_CARD_BLOCKED[]>(ApiUrl, reportParameters);
  }
  public SELECT_CARD_UNBLOCKED(reportParameters: ReportParameters): Observable<SELECT_CARD_UNBLOCKED[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_CARD_UNBLOCKED';
    return this.http.post<SELECT_CARD_UNBLOCKED[]>(ApiUrl, reportParameters);
  }
  public SELECT_ANTI_PASS_BACK_RESET(reportParameters: ReportParameters): Observable<SELECT_ANTI_PASS_BACK_RESET[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_ANTI_PASS_BACK_RESET';
    return this.http.post<SELECT_ANTI_PASS_BACK_RESET[]>(ApiUrl, reportParameters);
  }
  public SELECT_CARD_SOLD(reportParameters: ReportParameters): Observable<SELECT_CARD_SOLD[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_CARD_SOLD';
    return this.http.post<SELECT_CARD_SOLD[]>(ApiUrl, reportParameters);
  }
  public SELECT_CARD_RENEWED(reportParameters: ReportParameters): Observable<SELECT_CARD_RENEWED[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_CARD_RENEWED';
    return this.http.post<SELECT_CARD_RENEWED[]>(ApiUrl, reportParameters);
  }
  public SHIFT_SUMMARY(reportParameters: ReportParameters): Observable<SHIFT_SUMMARY> {
    const ApiUrl = this.BaseApiPath + 'report/SHIFT_SUMMARY';
    return this.http.post<SHIFT_SUMMARY>(ApiUrl, reportParameters);
  }
  public SELECT_PAYMENT_WITH_FASTAGE(reportParameters: ReportParameters): Observable<SELECT_PAYMENT_WITH_FASTAGE[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_PAYMENT_WITH_FASTAGE';
    return this.http.post<SELECT_PAYMENT_WITH_FASTAGE[]>(ApiUrl, reportParameters);
  }
  public SELECT_PAYMENT_WITH_FASTAGE_EXIT_ONLY(reportParameters: ReportParameters): Observable<SELECT_PAYMENT_WITH_FASTAGE[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_PAYMENT_WITH_FASTAGE_EXIT_ONLY';
    return this.http.post<SELECT_PAYMENT_WITH_FASTAGE[]>(ApiUrl, reportParameters);
  }
  public SELECT_PAYMENT_WITH_FASTAGE_ANDROID(reportParameters: ReportParameters): Observable<SELECT_PAYMENT_WITH_FASTAGE[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_PAYMENT_WITH_FASTAGE_ANDROID';
    return this.http.post<SELECT_PAYMENT_WITH_FASTAGE[]>(ApiUrl, reportParameters);
  }
  public SELECT_GROUP_COUNTER(reportParameters: ReportParameters): Observable<SELECT_GROUP_COUNTER[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_GROUP_COUNTER';
    return this.http.post<SELECT_GROUP_COUNTER[]>(ApiUrl, reportParameters);
  }
  public SELECT_MANUAL_BARRIER_OPEN_CLOSE(reportParameters: ReportParameters): Observable<SELECT_MANUAL_BARRIER_OPEN_CLOSE[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_MANUAL_BARRIER_OPEN_CLOSE';
    return this.http.post<SELECT_MANUAL_BARRIER_OPEN_CLOSE[]>(ApiUrl, reportParameters);
  }
  public SELECT_FASTAG_RECONCILATION_LIST(reportParameters: ReportParameters): Observable<SELECT_FASTAG_RECONCILATION[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_FASTAG_RECONCILATION_LIST';
    return this.http.post<SELECT_FASTAG_RECONCILATION[]>(ApiUrl, reportParameters);
  }
  public SELECT_KNOCK_OFF(reportParameters: ReportParameters): Observable<SELECT_KNOCK_OFF[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_KNOCK_OFF';
    return this.http.post<SELECT_KNOCK_OFF[]>(ApiUrl, reportParameters);
  }
  public SELECT_ALL_MOVEMENTS_BY_DAY_REP(reportParameters: ReportParameters): Observable<SELECT_ALL_MOVEMENTS_BY_DAY_REP[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_ALL_MOVEMENTS_BY_DAY_REP';
    return this.http.post<SELECT_ALL_MOVEMENTS_BY_DAY_REP[]>(ApiUrl, reportParameters);
  }
  public SELECT_RECONCILLATION_STATISTICS_REP(reportParameters: ReportParameters): Observable<SELECT_RECONCILLATION_STATISTICS_REP[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_RECONCILLATION_STATISTICS_REP';
    return this.http.post<SELECT_RECONCILLATION_STATISTICS_REP[]>(ApiUrl, reportParameters);
  }
  public SELECT_REVENUE_STATISTICS_REP(reportParameters: ReportParameters): Observable<SELECT_REVENUE_STATISTICS_REP[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_REVENUE_STATISTICS_REP';
    return this.http.post<SELECT_REVENUE_STATISTICS_REP[]>(ApiUrl, reportParameters);
  }
  public SELECT_STAY_TIME_STAMP_REPORT(reportParameters: ReportParameters): Observable<SELECT_STAY_TIME_STAMP_REPORT[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_STAY_TIME_STAMP_REPORT';
    return this.http.post<SELECT_STAY_TIME_STAMP_REPORT[]>(ApiUrl, reportParameters);
  }
  public Get_Cab_Report(reportParameters: ReportParameters): Observable<Get_Cab_Report[]> {
    const ApiUrl = this.BaseApiPath + 'report/Get_Cab_Report';
    return this.http.post<Get_Cab_Report[]>(ApiUrl, reportParameters);
  }
  public GET_CABCARDWISE_SUMMARY(reportParameters: ReportParameters): Observable<GET_CABCARDWISE_SUMMARY[]> {
    const ApiUrl = this.BaseApiPath + 'report/GET_CABCARDWISE_SUMMARY';
    return this.http.post<GET_CABCARDWISE_SUMMARY[]>(ApiUrl, reportParameters);
  }
  public GET_CABCARD_DETAILS(reportParameters: ReportParameters): Observable<GET_CABCARD_DETAILS[]> {
    const ApiUrl = this.BaseApiPath + 'report/GET_CABCARD_DETAILS';
    return this.http.post<GET_CABCARD_DETAILS[]>(ApiUrl, reportParameters);
  }
  public GET_CAB_SUMMARY(reportParameters: ReportParameters): Observable<GET_CAB_SUMMARY[]> {
    const ApiUrl = this.BaseApiPath + 'report/GET_CAB_SUMMARY';
    return this.http.post<GET_CAB_SUMMARY[]>(ApiUrl, reportParameters);
  }
  public SELECT_OFFLINE_FASTAG_REPORT(reportParameters: ReportParameters): Observable<OFFLINE_FASTAG_DATA[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_OFFLINE_FASTAG_REPORT';
    return this.http.post<OFFLINE_FASTAG_DATA[]>(ApiUrl, reportParameters);
  }
  public SELECT_OFFLINE_FASTAG_UPDATE_DATABASE_REPORT(reportParameters: ReportParameters): Observable<OFFLINE_FASTAG_DATA[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_OFFLINE_FASTAG_UPDATE_DATABASE_REPORT';
    return this.http.post<OFFLINE_FASTAG_DATA[]>(ApiUrl, reportParameters);
  }
  public Get_PreBooking_ExtraCharges(reportParameters: ReportParameters): Observable<PREBOOKING[]> {
    const ApiUrl = this.BaseApiPath + 'report/Get_PreBooking_ExtraCharges';
    return this.http.post<PREBOOKING[]>(ApiUrl, reportParameters);
  }
  public Booking_facility_Avail(reportParameters: ReportParameters): Observable<PREBOOKING[]> {
    const ApiUrl = this.BaseApiPath + 'report/Booking_facility_Avail';
    return this.http.post<PREBOOKING[]>(ApiUrl, reportParameters);
  }

  public SELECT_HANDHELD_MOMENT(reportParameters: ReportParameters): Observable<SELECT_PAYMENT_WITH_FASTAGE[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_HANDHELD_MOMENT';
    return this.http.post<SELECT_PAYMENT_WITH_FASTAGE[]>(ApiUrl, reportParameters);
  }
  public SELECT_PAYMENT_WITH_HANHELD(reportParameters: ReportParameters): Observable<SELECT_PAYMENT_WITH_FASTAGE[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_PAYMENT_WITH_HANDHELD_1';
    return this.http.post<SELECT_PAYMENT_WITH_FASTAGE[]>(ApiUrl, reportParameters);
  }
  public SELECT_T1_COMMERCIAL(reportParameters: ReportParameters): Observable<SELECT_T1__COMMERCIAL[]> {
    const ApiUrl = this.BaseApiPath + 'report/T1_Parking';
    return this.http.post<SELECT_T1__COMMERCIAL[]>(ApiUrl, reportParameters);
  }
  public SELECT_T1_PRIVATE(reportParameters: ReportParameters): Observable<SELECT_T1__PRIVATE[]> {
    const ApiUrl = this.BaseApiPath + 'report/T1_Parking';
    return this.http.post<SELECT_T1__PRIVATE[]>(ApiUrl, reportParameters);
  }
  public SELECT_T1_FORECOURT(reportParameters: ReportParameters): Observable<SELECT_T1__FORECOURT[]> {
    const ApiUrl = this.BaseApiPath + 'report/T1_ForeCourt';
    return this.http.post<SELECT_T1__FORECOURT[]>(ApiUrl, reportParameters);
  }
  public SELECT_HANDHELD_MANUAL(reportParameters: ReportParameters): Observable<SELECT_HANDHELD_MANUAL[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_HANDHELD_MANUAL';
    return this.http.post<SELECT_HANDHELD_MANUAL[]>(ApiUrl, reportParameters);
  }
  public SELECT_HANDHELD_LOSTTICKET(reportParameters: ReportParameters): Observable<SELECT_HANDHELD_MANUAL[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_HANDHELD_LOSTTICKET';
    return this.http.post<SELECT_HANDHELD_MANUAL[]>(ApiUrl, reportParameters);
  }
  public SELECT_T1_ENTRIES(reportParameters: ReportParameters): Observable<SELECT_T1__ENTRIES[]> {
    const ApiUrl = this.CloudApi_Path + 'report/GetT1_PendingData';
    return this.http.post<SELECT_T1__ENTRIES[]>(ApiUrl, reportParameters);
  }
  public SELECT_ANPR_MOVEMENT(reportParameters: ReportParameters): Observable<SELECT_ANPR[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_ANPR_MOVEMENT';
    return this.http.post<SELECT_ANPR[]>(ApiUrl, reportParameters);
  }
  public SELECT_ANPR_PAYMENT(reportParameters: ReportParameters): Observable<SELECT_ANPR[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_ANPR_PAYMENT';
    return this.http.post<SELECT_ANPR[]>(ApiUrl, reportParameters);
  }
  public SELECT_ANPR_DATA(reportParameters: ReportParameters): Observable<SELECT_ANPRDATA[]> {
    const ApiUrl = this.BaseApiPath + 'report/SELECT_ANPR_RAWDATA';
    return this.http.post<SELECT_ANPRDATA[]>(ApiUrl, reportParameters);
  }
}
